export default "__VITE_ASSET__BDrOAzzv__"